import { render } from "./Dispatch.vue?vue&type=template&id=3bb322ef&ts=true"
import script from "./Dispatch.vue?vue&type=script&lang=ts"
export * from "./Dispatch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__